<script setup lang="ts">
import { PhPlus, PhSparkle, PhX } from "@phosphor-icons/vue";
</script>

<template>
  <dialog
    id="analysisDialog"
    class="analysis-dialog"
    aria-labelledby="analysisDialogTitle"
    aria-describedby="analysisDialogDescription"
  >
    <form id="analysisForm" method="dialog">
      <div class="analysis-dialog-heading">
        <span class="analysis-dialog-icon" aria-hidden="true">
          <PhSparkle :size="16" weight="fill" />
        </span>
        <div>
          <h2 id="analysisDialogTitle">智能筛选</h2>
          <p id="analysisDialogDescription">智能筛选会检查当前页面检测到的全部素材。</p>
        </div>
      </div>

      <div class="analysis-dialog-field">
        <span id="analysisKeywordLabel">排除关键词</span>
        <div
          id="analysisKeywordEditor"
          class="analysis-keyword-editor"
          role="group"
          tabindex="-1"
          aria-labelledby="analysisKeywordLabel"
          aria-describedby="analysisTermsHint analysisDialogMessage"
        >
          <button id="analysisKeywordAdd" class="analysis-keyword-add" type="button">
            <PhPlus :size="12" weight="bold" aria-hidden="true" />
            <span>添加关键词</span>
          </button>
          <input
            id="analysisKeywordInput"
            class="analysis-keyword-input"
            type="text"
            autocomplete="off"
            aria-label="输入排除关键词"
            aria-describedby="analysisTermsHint analysisDialogMessage"
            hidden
          />
        </div>
        <input id="analysisTermsInput" type="hidden" />
        <span id="analysisKeywordRemoveIconTemplate" hidden>
          <PhX :size="12" weight="bold" aria-hidden="true" />
        </span>
      </div>
      <p id="analysisTermsHint" class="visually-hidden">输入一个关键词后按 Enter 添加。</p>
      <p id="analysisDialogMessage" class="analysis-dialog-message" role="alert" hidden></p>

      <div class="analysis-dialog-actions">
        <button id="analysisCancelButton" class="secondary-button" type="button">取消</button>
        <button id="analysisStartButton" class="analysis-start-button" type="submit" disabled>
          开始筛选
        </button>
      </div>
    </form>
  </dialog>
</template>
